import * as React from "react"
import { SelectSeeker } from "@ui-seeker/core"

import { categoryFake } from "@signals";


const OPTIONS = ['Fragrances', 'Make Up', 'Prestige', 'Niche', 'Fashion', 'Hair', 'Care', 'Cosmetics', 'Corporal'].map(category => ({
	label: category, value: category
}))

export default function DIPCategoryFakeSelect({ options, ...props }) {

    return <SelectSeeker
        options={OPTIONS}
        label="Categories"
		placeholder="All Categories"
		multiple
		isClearable
        value={categoryFake.value}
        onChange={e => categoryFake.value = e.target.value}
        {...props}
    />
}